export default __webpack_public_path__ + "static/media/home-travel-agency-destination-img07.f79d6821.jpg";